import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { AuthService, AuthGuard } from './auth';
import { DevGuard } from './auth/guards';
import { UiService } from './ui.service';

import { LayoutComponent } from './layout/layout.component';

import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,

        SharedModule,
    ],
    exports: [],
    providers: [AuthService, AuthGuard, DevGuard, UiService],
    declarations: [LayoutComponent],
})
export class CoreModule {}
